exports = function(val) {
    return val == null ? '' : val.toString();
};

module.exports = exports;
